import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { getViolationsFromCategoryFAIDMapping } from '@bingads-webui-campaign/delivery-status-popup-factory';
import template from './policy-status.pug';


export class ColumnPolicyStatus extends CampaignuiBaseColumn {
  constructor({
    i18n, view, scope, serverContext, permissions,
  }) {
    const title = i18n.getString('ColumnName_PolicyStatus');

    super({
      name: 'PolicyStatus',
      property: ['EditorialStatus', 'EditorialCategory'],
      sortable: 'EditorialStatus',
      title,
      type: 'string',
      bodyClasses: 'grid-column-Delivery',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.view = view;
    this.scope = scope;
    this.serverContext = serverContext;
    this.permissions = permissions;
  }

  get property() {
    return {
      get: ({ EditorialStatus, EditorialCategories }) => ({
        EditorialStatus, EditorialCategories,
      }),
    };
  }

  template({ value }) {
    const { EditorialCategories } = value;
    const EditorialStatus = value.EditorialStatus || '-';
    const errorStatusList = [
      'Rejected',
      'RejectedAppealRejected',
    ];

    const whiteList = [
      'Approved',
      'ApprovedLimited',
      'ApprovedLimitedAppealRejected',
      '-',
    ];
    const inWhiteList = _.contains(whiteList, EditorialStatus);
    const isErrorStatus = _.contains(errorStatusList, EditorialStatus);
    const isWarningStatus = !inWhiteList && !isErrorStatus;

    const hasRejectReasonWhitelist = [
      'Approved',
      '-',
    ];

    const showRejectPopup = !_.contains(hasRejectReasonWhitelist, EditorialStatus);
    const shouldEditorialCategoriesPopup = getViolationsFromCategoryFAIDMapping(EditorialCategories).length > 0;

    return template({
      Id: value.Id,
      isErrorStatus,
      isWarningStatus,
      showRejectPopup: showRejectPopup || shouldEditorialCategoriesPopup,
      DeliveryStatus: EditorialStatus,
      i18n: this.i18n,
      isForVNext: this.isForVNext,
      shouldShowSensitiveContentWarning: shouldEditorialCategoriesPopup,
      shouldShowPopUpStyleInVnext: showRejectPopup,
    });
  }
}
